import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {Accordion, Button, Col, Row} from "react-bootstrap";
import {OccActimodelForm} from "../components/forms/OccActimodelForm";
import {AmodelForm} from "../components/forms/AmodelForm";
import {BmodelForm} from "../components/forms/BmodelForm";
import {CmodelForm} from "../components/forms/CmodelForm";
import {DmodelForm} from "../components/forms/DmodelForm";
import {useEmailMutations} from "../api/emailapi";
import {PdfViewerCustom} from "../components/PdfViewerCustom";
import {pdfjs} from "react-pdf";
import React, {useEffect, useRef, useState} from "react";
import {IfLoggedIn, IfNotLoggedIn} from "../components/ifLoggedIn";
import {ToastContainer} from "react-toastify";
import {useAuthenticated} from "../contexts/authenticationcontext";
import {minioBaseUrl} from "../data/defaultConfig";
import {Section} from "../components/grouping/Section";
import {FaCloudDownloadAlt} from "react-icons/fa";

export function AdministrationPage(props) {
    const {createFormEmail} = useEmailMutations();
    const {role} = useAuthenticated();
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
    ).toString();
    const refContainer = useRef();
    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 0,
    });
    useEffect(() => {
        function handleResize() {
            setDimensions({
                width: refContainer.current.offsetWidth,
                height: refContainer.current.offsetHeight,
            });
        }

        window.addEventListener('resize', handleResize)
        handleResize();
    }, []);
    const docsMutatieClub = [
        {uri: "http://185.115.217.122:9000/vbflw/mutatie%20club.pdf"}];
    const docsMutatie = [
        {uri: "http://185.115.217.122:9000/vbflw/mutatie.pdf"}];
    const docsKalenderClubs = [
        {uri: "http://185.115.217.122:9000/vbflw/kalenderClubs.pdf"}];

    function handleEmail() {
        console.log({
            title: "test",
            subject: "lols",
            emailto: "vannieuland.geordi@gmail.com",
            emailfrom: "Vbflw@test.be",
            description: "qsdfqsdfqdsfqdsfqdsfqds",
            attachment: 1
        })
        const response = createFormEmail({
            title: "test",
            subject: "lols",
            emailto: "vannieuland.geordi@gmail.com",
            emailfrom: "administratie@vbflw.be",
            description: "qsdfqsdfqdsfqdsfqdsfqds",
            attachment: 1
        })
    }

    return <BasePageLayout title={'Administratie'}>
        <IfNotLoggedIn>
            <p>Voor deze pagina moet u ingelogd zijn. <span><Button href={'/login'}>Log hier in</Button></span></p>
        </IfNotLoggedIn>
        <div ref={refContainer}>
            <IfLoggedIn>
                <p>Op deze pagina kan u een aantal formulieren online invullen. De formulieren Mutatie Club, Mutatie en
                    Kalender
                    Clubs kan u enkel downloaden.</p>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Model A Inschrijvingsformulier 'leden'
                        </Accordion.Header>
                        <Accordion.Body>
                            <AmodelForm/>
                        </Accordion.Body>
                    </Accordion.Item>
                    {role === 'ROLE_ADMIN' ? <AdminForms/> : ""}
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Occasionele activiteit
                        </Accordion.Header>
                        <Accordion.Body>
                            <OccActimodelForm/>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Download Mutatie Club
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className={"g-0"}>
                                <Col className={"align-center"}>
                                    <Button
                                        href={minioBaseUrl + "/mutatie%20club.pdf"}
                                        target={"_blank"}
                                        className={" btn-light ms-1 border-black mb-2 w-100"}
                                        aria-controls="example-collapse-text"

                                    >
                                        <Section>
                                            <Col>
                                                <FaCloudDownloadAlt/>
                                            </Col>
                                        </Section>
                                    </Button>
                                </Col>
                            </Row>
                            <PdfViewerCustom parentWidth={dimensions.width} url={"/mutatie%20club.pdf"}/>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Download Mutatie
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className={"g-0"}>
                                <Col className={"align-center"}>
                                    <Button
                                        href={minioBaseUrl + "/mutatie.pdf"}
                                        target={"_blank"}
                                        className={" btn-light ms-1 border-black mb-2 w-100"}
                                        aria-controls="example-collapse-text"

                                    >
                                        <Section>
                                            <Col>
                                                <FaCloudDownloadAlt/>
                                            </Col>
                                        </Section>
                                    </Button>
                                </Col>
                            </Row>
                            <PdfViewerCustom parentWidth={dimensions.width} url={"/mutatie.pdf"}/>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                        <Accordion.Header>Download Kalender Clubs
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className={"g-0"}>
                                <Col className={"align-center"}>
                                    <Button
                                        href={minioBaseUrl + "/kalenderClubs.pdf"}
                                        target={"_blank"}
                                        className={" btn-light ms-1 border-black mb-2 w-100"}
                                        aria-controls="example-collapse-text"

                                    >
                                        <Section>
                                            <Col>
                                                <FaCloudDownloadAlt/>
                                            </Col>
                                        </Section>
                                    </Button>
                                </Col>
                            </Row>
                            <PdfViewerCustom parentWidth={dimensions.width} url={"/kalenderClubs.pdf"}/>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <ToastContainer/>
            </IfLoggedIn>
        </div>

    </BasePageLayout>
}


function AdminForms(props) {
    return <>
        <Accordion.Item eventKey="1">
            <Accordion.Header>Model B Inschrijvingsformulier 'Club'
            </Accordion.Header>
            <Accordion.Body>
                <BmodelForm/>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
            <Accordion.Header>Model C Inschrijvingsformulier 'Sector'
            </Accordion.Header>
            <Accordion.Body>
                <CmodelForm/>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
            <Accordion.Header>Model D Inschrijvingsformulier 'Provincie'
            </Accordion.Header>
            <Accordion.Body>
                <DmodelForm/>
            </Accordion.Body>
        </Accordion.Item>
    </>
}






